
import React from 'react';

export const SearchIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    search
  </span>
);